export enum FundRaiseRole {
  Director = 1,
  Shareholder = 2,
}
